'use client';

import { useSearchParams } from 'next/navigation';

import useTranslation from '@/utils/hooks/translation/useTranslation';
import useCurrentSession from '@/utils/hooks/user/useCurrentSession';

import { FORGOT_PASSWORD, SIGN_UP } from '@/lib/routes/publicRoutes';

import LinkBase from '@/components/base/LinkBase';
import LoaderPage from '@/components/base/Loader/LoaderPage';
import LayoutSignIn from '@/components/layouts/LayoutSignIn';
import LatestUpdates from '@/components/pages/signin/LatestUpdates';
import SignInForm from '@/components/pages/signin/SignInForm';

export default function SignInPage() {
    const { t: tSignin } = useTranslation('signin');
    const { isLoading, user } = useCurrentSession({ isLoggedRedirect: true });
    const searchParams = useSearchParams();

    if (isLoading || user) {
        return <LoaderPage />;
    }

    return (
        <LayoutSignIn emailUpdated={searchParams.get('email_updated') === 'true'}>
            <SignInForm />
            <div className="flex items-center justify-center">
                <LinkBase
                    href={FORGOT_PASSWORD}
                    className="mt-3 text-center font-GMedium text-xs text-icoGray-500 underline">
                    {tSignin('forgot_your_password')}
                </LinkBase>
            </div>
            <p className="mt-10 text-center font-GSemiBold text-sm">
                {tSignin('not_registered_yet')}
                <LinkBase href={SIGN_UP} className="ml-1 text-icoBlue" data-testid="signup-link">
                    {tSignin('sign_up')}
                </LinkBase>
            </p>
            <div className="absolute bottom-10 right-10 hidden lg:block">
                <LatestUpdates />
            </div>
        </LayoutSignIn>
    );
}
